import AirbnbReviewsScraper from './airbnb-reviews-scraper.svg';
import AirbnbReviewsSentimentAnalysis from './airbnb-reviews-sentiment-analysis.svg';
import AirbnbReviewsSummary from './airbnb-reviews-summary.svg';
import AirbnbSearchScraper from './airbnb-search-scraper.svg';
import AdsChecker from './ads-checker.svg';
import AllegroScraper from './allegro-scraper.svg';
import AmazonProductsScraper from './amazon-products-scraper.svg';
import AmazonReviewsScraper from './amazon-reviews-scraper.svg';
import AngiScraper from './angi-scraper.svg';
import ApolloScraper from './apollo-scraper.svg';
import AppStoreReviewsScraper from './appstore-reviews-scraper.svg';
import AppStoreSearchScraper from './appstore-search-scraper.svg';
import AsosProductsScraper from './asos-products-scraper.svg';
import AutozoneProductsScraper from './autozone-products-scraper.svg';
import BBBBusinessScraper from './bbb-business-scraper.svg';
import BaiduMapsScraper from './baidu-maps-scraper.svg';
import BestBuyProductsScraper from './bestbuy-products-scraper.svg';
import BestBuyReviewsScraper from './bestbuy-reviews-scraper.svg';
import BestBuyReviewsSentimentAnalysis from './bestbuy-reviews-sentiment-analysis.svg';
import BestBuyReviewsSummary from './bestbuy-reviews-summary.svg';
import BiggestBookProductsScraper from './biggestbook-products-scraper.svg';
import BingMapsScraper from './bing-maps-scraper.svg';
import BookingPricesScraper from './booking-prices-scraper.svg';
import BookingReviewsMonitoring from './booking-reviews-monitoring.svg';
import BookingReviewsScraper from './booking-reviews-scraper.svg';
import BookingReviewsSentimentAnalysis from './booking-reviews-sentiment-analysis.svg';
import BookingReviewsSummary from './booking-reviews-summary.svg';
import BookingSearchScraper from './booking-search-scraper.svg';
import BootsProductsScraper from './boots-products-scraper.svg';
import BradyIndustriesProductsScraper from './bradyindustries-products-scraper.svg';
import BuiltWithScraper from './builtwith-scraper.svg';
import BusinessDirectory from './business-directory.svg';
import CDWProductsScraper from './cdw-products-scraper.svg';
import CapterraReviewsScraper from './capterra-reviews-scraper.svg';
import ChainInfo from './chain-info.svg';
import CompanyInsights from './company-insights.svg';
import CompanyWebsiteFinder from './company-website-finder.svg';
import ContactsFinder from './contacts-finder.svg';
import CostcoProductsScraper from './costco-products-scraper.svg';
import CraigslistScraper from './craigslist-scraper.svg';
import CrunchbaseScraper from './crunchbase-scraper.svg';
import CrunchbaseSearchScraper from './crunchbase-search-scraper.svg';
import CustominkProductsScraper from './customink-products-scraper.svg';
import DecathlonProductsScraper from './decathlon-products-scraper.svg';
import DeliverooReviewsScraper from './deliveroo-reviews-scraper.svg';
import DeliverooScraper from './deliveroo-scraper.svg';
import DisposableEmailChecker from './disposable-email-checker.svg';
import DomainInformation from './domain-information.svg';
import DoordashScraper from './doordash-scraper.svg';
import EbayProductsScraper from './ebay-products-scraper.svg';
import EmailAddressVerifier from './email-address-verifier.svg';
import EmailAddressesFinder from './email-addresses-finder.svg';
import EmailsContactsScraper from './domains-service.svg';
import EtsyProductsScraper from './etsy-products-scraper.svg';
import EtsyReviewsScraper from './etsy-reviews-scraper.svg';
import EtsyReviewsSentimentAnalysis from './etsy-reviews-sentiment-analysis.svg';
import EtsyReviewsSummary from './etsy-reviews-summary.svg';
import EventbriteListingsScraper from './eventbrite-listings-scraper.svg';
import ExpediaReviewsScraper from './expedia-reviews-scraper.svg';
import ExpediaReviewsSentimentAnalysis from './expedia-reviews-sentiment-analysis.svg';
import ExpediaReviewsSummary from './expedia-reviews-summary.svg';
import ExpediaSearchScraper from './expedia-search-scraper.svg';
import FastbackgroundcheckAddressesScraper from './fastbackgroundcheck-addresses-scraper.svg';
import FastenalProductsScraper from './fastenal-products-scraper.svg';
import FeedbackCompanyReviewsScraper from './feedbackcompany-reviews-scraper.svg';
import FeedbackCompanyScraper from './feedbackcompany-scraper.svg';
import FeefoReviewsScraper from './feefo-reviews-scraper.svg';
import FergusonProductsScraper from './ferguson-products-scraper.svg';
import G2ReviewsScraper from './g2-reviews-scraper.svg';
import GemplersProductsScraper from './gemplers-products-scraper.svg';
import Geocoding from './geocoding.svg';
import GetAppReviewsScraper from './getapp-reviews-scraper.svg';
import GlassdoorCompanyJobs from './glassdoor-company-jobs.svg';
import GlassdoorCompanySearch from './glassdoor-company-search.svg';
import GlassdoorJobScraper from './glassdoor-job-scraper.svg';
import GlassdoorReviewsScraper from './glassdoor-reviews-scraper.svg';
import GlassdoorReviewsSentimentAnalysis from './glassdoor-reviews-sentiment-analysis.svg';
import GlassdoorReviewsSummary from './glassdoor-reviews-summary.svg';
import GlobalIndustrialProductsScraper from './globalindustrial-products-scraper.svg';
import GraingerProductsScraper from './grainger-products-scraper.svg';
import GrouponProductsScraper from './groupon-products-scraper.svg';
import HomeDepotProductsScraper from './homedepot-products-scraper.svg';
import HomeDepotReviewsScraper from './homedepot-reviews-scraper.svg';
import HomeDepotReviewsSentimentAnalysis from './homedepot-reviews-sentiment-analysis.svg';
import HomeDepotReviewsSummary from './homedepot-reviews-summary.svg';
import HotelsReviewsScraper from './hotels-reviews-scraper.svg';
import HotelsReviewsSentimentAnalysis from './hotels-reviews-sentiment-analysis.svg';
import HotelsReviewsSummary from './hotels-reviews-summary.svg';
import HotelsSearchScraper from './hotels-search-scraper.svg';
import HubSpotCompanyContactsFinder from './hubspot-company-contacts-finder.svg';
import HubSpotContactEmailsFinder from './hubspot-contact-emails-finder.svg';
import IPInfoScraper from './ipinfo-scraper.svg';
import ImmoweltScraper from './immowelt-scraper.svg';
import IndeedJobScraper from './indeed-job-scraper.svg';
import IndeedReviewsScraper from './indeed-reviews-scraper.svg';
import IndeedReviewsSentimentAnalysis from './indeed-reviews-sentiment-analysis.svg';
import IndeedReviewsSummary from './indeed-reviews-summary.svg';
import ItemInfoProductsScraper from './iteminfo-products-scraper.svg';
import LinkedinCompaniesScraper from './linkedin-companies-scraper.svg';
import LinkedinPostsScraper from './linkedin-posts-scraper.svg';
import LinkedinProfilesScraper from './linkedin-profiles-scraper.svg';
import LowesProductsScraper from './lowes-products-scraper.svg';
import LyrecoProductsScraper from './lyreco-products-scraper.svg';
import MacysProductsScraper from './macys-products-scraper.svg';
import MeetupListingsScraper from './meetup-listings-scraper.svg';
import MenardsProductsScraper from './menards-products-scraper.svg';
import MobiledeScraper from './mobilede-scraper.svg';
import NapaOnlineProductsScraper from './napaonline-products-scraper.svg';
import NeweggProductsScraper from './newegg-products-scraper.svg';
import NortherntoolProductsScraper from './northerntool-products-scraper.svg';
import OLXScraper from './olx-scraper.svg';
import OfferupScraper from './offerup-scraper.svg';
import OfficeDepotProductsScraper from './officedepot-products-scraper.svg';
import OttoProductsScraper from './otto-products-scraper.svg';
import PhoneIdentityFinder from './phone-identity-finder.svg';
import PhoneNumbersEnricher from './phone-numbers-enricher.svg';
import PinterestBoardScraper from './pinterest-board-scraper.svg';
import ProductHuntProfilesScraper from './producthunt-profiles-scraper.svg';
import ProductHuntReviewsScraper from './product-hunt-reviews-scraper.svg';
import QuillProductsScraper from './quill-products-scraper.svg';
import RedditCommentsScraper from './reddit-comments-scraper.svg';
import RedditSearchScraper from './reddit-search-scraper.svg';
import ReverseGeocoding from './reverse-geocoding.svg';
import SamsClubProductsScraper from './samsclub-products-scraper.svg';
import Search1688Scraper from './1688-search-scraper.svg';
import ShopeeReviewsScraper from './shopee-reviews-scraper.svg';
import ShopifyAppsScraper from './shopify-apps-scraper.svg';
import ShopifyProductsScraper from './shopify-products-scraper.svg';
import SimilarWebScraper from './similarweb-scraper.svg';
import StaplesProductsScraper from './staples-products-scraper.svg';
import StreetEasyListingsScraper from './streeteasy-listings-scraper.svg';
import TargetProductsScraper from './target-products-scraper.svg';
import TargetReviewsScraper from './target-reviews-scraper.svg';
import TargetReviewsSentimentAnalysis from './target-reviews-sentiment-analysis.svg';
import TargetReviewsSummary from './target-reviews-summary.svg';
import TescoProductsScraper from './tesco-products-scraper.svg';
import ThuisbezorgdReviewsScraper from './thuisbezorgd-reviews-scraper.svg';
import TikTokCommentsScraper from './tiktok-comments-scraper.svg';
import TikTokHashtagsScraper from './tiktok-hashtags-scraper.svg';
import TikTokProductsScraper from './tiktok-products-scraper.svg';
import TikTokProfilesScraper from './tiktok-profiles-scraper.svg';
import TikTokSearchScraper from './tiktok-search-scraper.svg';
import TikTokVideosScraper from './tiktok-videos-scraper.svg';
import TripadvisorReviewsMonitoring from './tripadvisor-reviews-monitoring.svg';
import TripadvisorReviewsScraper from './tripadvisor-reviews-scraper.svg';
import TripadvisorReviewsSentimentAnalysis from './tripadvisor-reviews-sentiment-analysis.svg';
import TripadvisorReviewsSummary from './tripadvisor-reviews-summary.svg';
import TripadvisorSearchScraper from './tripadvisor-search-scraper.svg';
import TrustpilotReviewsMonitoring from './trustpilot-reviews-monitoring.svg';
import TrustpilotReviewsScraper from './trustpilot-reviews-scraper.svg';
import TrustpilotReviewsSentimentAnalysis from './trustpilot-reviews-sentiment-analysis.svg';
import TrustpilotReviewsSummary from './trustpilot-reviews-summary.svg';
import TrustpilotScraper from './trustpilot-scraper.svg';
import TrustpilotSearchScraper from './trustpilot-search-scraper.svg';
import TwitterProfilesScraper from './twitter-profiles-scraper.svg';
import USCompaniesDataEnricher from './us-companies-data-enricher.svg';
import UberEatsScraper from './ubereats-scraper.svg';
import UlineProductsScraper from './uline-products-scraper.svg';
import UniversalAIPoweredScraper from './universal-scraper.svg';
import UpworkJobs from './upwork-jobs.svg';
import VistaprintProductsScraper from './vistaprint-products-scraper.svg';
import VrboSearchScraper from './vrbo-search-scraper.svg';
import WalmartProductsScraper from './walmart-products-scraper.svg';
import WalmartReviewsScraper from './walmart-reviews-scraper.svg';
import WalmartReviewsSentimentAnalysis from './walmart-reviews-sentiment-analysis.svg';
import WalmartReviewsSummary from './walmart-reviews-summary.svg';
import WaxieProductsScraper from './waxie-products-scraper.svg';
import WbmasonProductsScraper from './wbmason-products-scraper.svg';
import WebPageScreenshoter from './webpage-screenshoter.svg';
import WebstaurantstoreProductsScraper from './webstaurantstore-products-scraper.svg';
import WhatsAppChecker from './whatsapp-checker.svg';
import WhitepagesAddressesScraper from './whitepages-addresses-scraper.svg';
import WillhabenScraper from './willhaben-scraper.svg';
import YahooSearchScraper from './yahoo-search-scraper.svg';
import YellowPagesSearchScraper from './yellowpages-search-scraper.svg';
import YelpBusinessesScraper from './yelp-businesses-scraper.svg';
import YelpPhotosScraper from './yelp-photos-scraper.svg';
import YelpReviewsScraper from './yelp-reviews-scraper.svg';
import YelpReviewsSentimentAnalysis from './yelp-reviews-sentiment-analysis.svg';
import YelpReviewsSummary from './yelp-reviews-summary.svg';
import YouTubeChannelsScraper from './youtube-channels-scraper.svg';
import YouTubeCommentsScraper from './youtube-comments-scraper.svg';
import YouTubeCommentsSentimentAnalysis from './youtube-comments-sentiment-analysis.svg';
import YouTubeCommentsSummary from './youtube-comments-summary.svg';
import YouTubeSearchScraper from './youtube-search-scraper.svg';
import YouTubeTranscriptsScraper from './youtube-transcripts-scraper.svg';
import YouTubeVideoScraper from './youtube-video-scraper.svg';
import ZalandoProductsScraper from './zalando-products-scraper.svg';
import ZillowAgentsScraper from './zillow-agents-scraper.svg';
import ZillowReviewsScraper from './zillow-reviews-scraper.svg';
import ZillowSearchScraper from './zillow-search-scraper.svg';
import ZillowTransactionsScraper from './zillow-transactions-scraper.svg';
import ZoominfoByDomains from './zoominfo-by-domains.svg';
import ZoominfoScraper from './zoominfo-scraper.svg';
import ZoroProductsScraper from './zoro-products-scraper.svg';

export const otherIcons = {
  AirbnbReviewsScraper,
  AirbnbReviewsSentimentAnalysis,
  AirbnbReviewsSummary,
  AirbnbSearchScraper,
  AdsChecker,
  AllegroScraper,
  AmazonProductsScraper,
  AmazonReviewsScraper,
  AngiScraper,
  ApolloScraper,
  AppStoreReviewsScraper,
  AppStoreSearchScraper,
  AsosProductsScraper,
  AutozoneProductsScraper,
  BBBBusinessScraper,
  BaiduMapsScraper,
  BestBuyProductsScraper,
  BestBuyReviewsScraper,
  BestBuyReviewsSentimentAnalysis,
  BestBuyReviewsSummary,
  BiggestBookProductsScraper,
  BingMapsScraper,
  BookingPricesScraper,
  BookingReviewsMonitoring,
  BookingReviewsScraper,
  BookingReviewsSentimentAnalysis,
  BookingReviewsSummary,
  BookingSearchScraper,
  BootsProductsScraper,
  BradyIndustriesProductsScraper,
  BuiltWithScraper,
  BusinessDirectory,
  CDWProductsScraper,
  CapterraReviewsScraper,
  ChainInfo,
  CompanyInsights,
  CompanyWebsiteFinder,
  ContactsFinder,
  CostcoProductsScraper,
  CraigslistScraper,
  CrunchbaseScraper,
  CrunchbaseSearchScraper,
  CustominkProductsScraper,
  DecathlonProductsScraper,
  DeliverooReviewsScraper,
  DeliverooScraper,
  DisposableEmailChecker,
  DomainInformation,
  DoordashScraper,
  EbayProductsScraper,
  EmailAddressVerifier,
  EmailAddressesFinder,
  EmailsContactsScraper,
  EtsyProductsScraper,
  EtsyReviewsScraper,
  EtsyReviewsSentimentAnalysis,
  EtsyReviewsSummary,
  EventbriteListingsScraper,
  ExpediaReviewsScraper,
  ExpediaReviewsSentimentAnalysis,
  ExpediaReviewsSummary,
  ExpediaSearchScraper,
  FastbackgroundcheckAddressesScraper,
  FastenalProductsScraper,
  FeedbackCompanyReviewsScraper,
  FeedbackCompanyScraper,
  FeefoReviewsScraper,
  FergusonProductsScraper,
  G2ReviewsScraper,
  GemplersProductsScraper,
  Geocoding,
  GetAppReviewsScraper,
  GlassdoorCompanyJobs,
  GlassdoorCompanySearch,
  GlassdoorJobScraper,
  GlassdoorReviewsScraper,
  GlassdoorReviewsSentimentAnalysis,
  GlassdoorReviewsSummary,
  GlobalIndustrialProductsScraper,
  GraingerProductsScraper,
  GrouponProductsScraper,
  HomeDepotProductsScraper,
  HomeDepotReviewsScraper,
  HomeDepotReviewsSentimentAnalysis,
  HomeDepotReviewsSummary,
  HotelsReviewsScraper,
  HotelsReviewsSentimentAnalysis,
  HotelsReviewsSummary,
  HotelsSearchScraper,
  HubSpotCompanyContactsFinder,
  HubSpotContactEmailsFinder,
  IPInfoScraper,
  ImmoweltScraper,
  IndeedJobScraper,
  IndeedReviewsScraper,
  IndeedReviewsSentimentAnalysis,
  IndeedReviewsSummary,
  ItemInfoProductsScraper,
  LinkedinCompaniesScraper,
  LinkedinPostsScraper,
  LinkedinProfilesScraper,
  LowesProductsScraper,
  LyrecoProductsScraper,
  MacysProductsScraper,
  MeetupListingsScraper,
  MenardsProductsScraper,
  MobiledeScraper,
  NapaOnlineProductsScraper,
  NeweggProductsScraper,
  NortherntoolProductsScraper,
  OLXScraper,
  OfferupScraper,
  OfficeDepotProductsScraper,
  OttoProductsScraper,
  PhoneIdentityFinder,
  PhoneNumbersEnricher,
  PinterestBoardScraper,
  ProductHuntProfilesScraper,
  ProductHuntReviewsScraper,
  QuillProductsScraper,
  RedditCommentsScraper,
  RedditSearchScraper,
  ReverseGeocoding,
  SamsClubProductsScraper,
  Search1688Scraper,
  ShopeeReviewsScraper,
  ShopifyAppsScraper,
  ShopifyProductsScraper,
  SimilarWebScraper,
  StaplesProductsScraper,
  StreetEasyListingsScraper,
  TargetProductsScraper,
  TargetReviewsScraper,
  TargetReviewsSentimentAnalysis,
  TargetReviewsSummary,
  TescoProductsScraper,
  ThuisbezorgdReviewsScraper,
  TikTokCommentsScraper,
  TikTokHashtagsScraper,
  TikTokProductsScraper,
  TikTokProfilesScraper,
  TikTokSearchScraper,
  TikTokVideosScraper,
  TripadvisorReviewsMonitoring,
  TripadvisorReviewsScraper,
  TripadvisorReviewsSentimentAnalysis,
  TripadvisorReviewsSummary,
  TripadvisorSearchScraper,
  TrustpilotReviewsMonitoring,
  TrustpilotReviewsScraper,
  TrustpilotReviewsSentimentAnalysis,
  TrustpilotReviewsSummary,
  TrustpilotScraper,
  TrustpilotSearchScraper,
  TwitterProfilesScraper,
  USCompaniesDataEnricher,
  UberEatsScraper,
  UlineProductsScraper,
  UniversalAIPoweredScraper,
  UpworkJobs,
  VistaprintProductsScraper,
  VrboSearchScraper,
  WalmartProductsScraper,
  WalmartReviewsScraper,
  WalmartReviewsSentimentAnalysis,
  WalmartReviewsSummary,
  WaxieProductsScraper,
  WbmasonProductsScraper,
  WebPageScreenshoter,
  WebstaurantstoreProductsScraper,
  WhatsAppChecker,
  WhitepagesAddressesScraper,
  WillhabenScraper,
  YahooSearchScraper,
  YellowPagesSearchScraper,
  YelpBusinessesScraper,
  YelpPhotosScraper,
  YelpReviewsScraper,
  YelpReviewsSentimentAnalysis,
  YelpReviewsSummary,
  YouTubeChannelsScraper,
  YouTubeCommentsScraper,
  YouTubeCommentsSentimentAnalysis,
  YouTubeCommentsSummary,
  YouTubeSearchScraper,
  YouTubeTranscriptsScraper,
  YouTubeVideoScraper,
  ZalandoProductsScraper,
  ZillowAgentsScraper,
  ZillowReviewsScraper,
  ZillowSearchScraper,
  ZillowTransactionsScraper,
  ZoominfoByDomains,
  ZoominfoScraper,
  ZoroProductsScraper
};
